import css from "./css/settings.module.css";
import {MdCardMembership as MemberIcon} from "react-icons/md";
import {FaUserPlus} from "react-icons/fa";
import {BiWorld} from "react-icons/bi";
import {BsCreditCardFill as CreditIcon} from "react-icons/bs";
import {MdOutlineChevronRight as RightArrow} from "react-icons/md";
import {HiOutlineMail as EmailIcon} from "react-icons/hi";
import {MdOutlineFolderSpecial as CertIcon} from "react-icons/md";
import {TbCertificate as CertificateIcon} from "react-icons/tb";
import {Link,Routes,Route} from 'react-router-dom';
import {MdOutlineCastForEducation as QualifyIon} from "react-icons/md";
import {TbRouter as RoutespecialIcon} from "react-icons/tb";
import {GiMatterStates as StateIcon} from "react-icons/gi"
import {RiQuestionAnswerLine as StateIcon2} from "react-icons/ri"

import { 
  AdminRole,
  ScoreSetUp,
  Specialization,
  Qualification,
  // EmailTemplate,
  // CertificateScore,
  ApplicationPeriods,
  AdminUser,
  MembershipRoute,
  RoutePayment,
  DeactivateApplicant,
  PaymentDuration,
  Country,
  State,
  Lga,
  Claim,
  ApprovalConfig,
  Zones,
  ScoreType,
  Training,
  Induction,
  IndustrySetUp,
  CompanyClass,
  SetUpInterview,
  ExamEntrySetUp,
  CoreHrScoreSetUp,
  RoutePageEditor,
  HrTrainingScoreSetup,
  AttainmentScoreSetup,
  ResetApplicantPassword, VerifyEmail
} from '.';

import ScoreSetup from './ScoreSetup/main';
import ApprovalType from './ApprovalType/Main';
import Modal  from './Modal';
import { SettingModal } from '../../../hooks/Context';
// import IndustrySetUp from "./IndustrySetUp/IndustrySetUp";

const settingData = [
  { 
    path:"admin-user",
    name:"Admin User",
    icon:<FaUserPlus />,
    bgcolor:'#E1F5FE',
    color:'#00AAFF'
  },
  { 
    path:"membership-route",
    name:"Membership Route",
    icon:<MemberIcon />,
    bgcolor:'#FFF4DE',
    color:'#FEB930'
  },
  { 
    path:"payment-duration",
    name:"Payment Duration",
    icon:<CreditIcon />,
    bgcolor:'#F6EAFE',
    color:'#B54DF8'
  },
  { 
    path:"payment-route",
    name:"Payment Route",
    icon:<CreditIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271'
  },
  { 
    path:"application-periods",
    name:"Application Period",
    icon:<BiWorld />,
    bgcolor:'#E7F2E6',
    color:'#3C9D34',
  },
  // { 
  //   path:"email-templates",
  //   name:"Email Templates",
  //   icon:<EmailIcon />,
  //   bgcolor:'#F8EDF3',
  //   color:'#BD6F97'
  // },
  { 
    path:"specialization",
    name:"Specialization",
    icon:<RoutespecialIcon />,
    bgcolor:'#E1F5FE',
    color:'#00AAFF',
  },
  { 
    path:"admin-role",
    name:"Admin Role",
    icon:<FaUserPlus />,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  // { 
  //   path:"certificate-score",
  //   name:"Certificate Score",
  //   icon:<CertIcon/>,
  //   bgcolor:'#FFF1EE',
  //   color:'#FF9271'
  // },
  { 
    path:"qualification",
    name:"Qualification",
    icon:<QualifyIon />,
    bgcolor:'#E1F5FE',
    color:'#00AAFF',
  },
  { 
    path:"score-setup",
    name:"Score Setup",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#3C9D34',
  },
  { 
    path:"hr-training-score-setup",
    name:"HR Training Score Setup",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#3C9D34',
  },
  {
    path:"coreHr-score-setup",
    name:"CoreHr Score Setup",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#3C9D34',
  },
  { 
    path:"organizational-attainment-score-setup",
    name:"Organizational Attainment Score Setup",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#3C9D34',
  },
  { 
    path:"score-type",
    name:"Score Type",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#3C9D34',
  },
  { 
    path:"Approval-type",
    name:"Approval Type",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271',
  },
  { 
    path:"country",
    name:"Country",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271'
  },
  { 
    path:"state",
    name:"State",
    icon:<StateIcon/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8'
  },
  { 
    path:"lga",
    name:"LGA",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271'
  },
  // { 
  //   path:"claim",
  //   name:"Claim",
  //   icon:<CertificateIcon />,
  //   bgcolor:'#FFF1EE',
  //   color:'#3C9D34'
  // },
  {
    path:'approval-configuration',
    name:"Approval Configuration",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#B54DF8'
  },
  { 
    path:"zones",
    name:"Zones",
    icon:<RoutespecialIcon />,
    bgcolor:'#E1F5FE',
    color:'#00AAFF',
  },
  { 
    path:"training",
    name:"Training",
    icon:<BiWorld />,
    bgcolor:'#E7F2E6',
    color:'#3C9D34',
  },
  { 
    path:"induction",
    name:"Induction",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271'
  },
  { 
    path:"industrysetup",
    name:"Industry SetUp",
    icon:<StateIcon/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  { 
    path:"exam-entry-level-setup",
    name:"Entry Level SetUp",
    icon:<StateIcon/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  { 
    path:"set-up-interview",
    name:"Set Up Interview",
    icon:<StateIcon2/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  { 
    path:"route-page-editor",
    name:"Route Page Editor",
    icon:<StateIcon2/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  
  { 
    path:"companyclass",
    name:"Company Classification",
    icon:<StateIcon/>,
    bgcolor:'#FFF1EE',
    color:'#B54DF8',
  },
  { 
    path:"reset-applicant-password",
    name:"Reset Applicant Password",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#FF9271'
  },
  { 
    path:"deactivate-applicant",
    name:"Delete Applicant",
    icon:<CertificateIcon />,
    bgcolor:'#FFF1EE',
    color:'#530509'
  },
    { 
    path:"verify-user-email",
    name:"Verify Email",
    icon:<FaUserPlus />,
    bgcolor:'#E1F5FE',
    color:'#00AAFF'
  },
]

export const Settings = () => {
  return (
    <> 
      <SettingModal>
          <Routes>
          <Route index element={
          <>
            <div className={css.container}>
              <div>
                <h1>settings</h1>
                <div>
                  {settingData && settingData.length > 0 ? 
                  settingData.map((eData:any,index:number):any => 
                    <Link to={eData.path} key={index}>
                      <span style={{backgroundColor:eData.bgcolor,color:eData.color}}>{eData.icon}</span>
                      <span>{eData.name}</span>
                      <span><RightArrow /></span>
                    </Link>
                  ):''}

                </div>
              </div>
              
            </div>
          
        </>}/>
        <Route index element={
          <Settings />
        } />
        <Route path="/admin-user/*" element={<AdminUser/>}/>
        <Route path="/membership-route/*" element={<MembershipRoute/>}/>
        <Route path="/payment-duration/*" element={<PaymentDuration/>}/>
        <Route path="/qualification/*" element={<Qualification/>}/>
        <Route path="/payment-route/*" element={<RoutePayment/>}/>
        {/* <Route path="/certificate-score/*" element={<ScoreSetup/>}/> */}
        <Route path="/application-periods/*" element={<ApplicationPeriods/>}/>
        {/* <Route path="/email-templates/*" element={<EmailTemplate/>}/> */}
        <Route path="/specialization/*" element={<Specialization />}/>
        <Route path="/admin-role/*" element={<AdminRole/>}/>
        <Route path="/membership-route/*" element={<MembershipRoute/>}/>
        <Route path="/Approval-type/*" element={<ApprovalType/>}/>
        <Route path="/score-setup/*" element={<ScoreSetUp/>}/>
        <Route path="/hr-training-score-setup/*" element={<HrTrainingScoreSetup/>}/>
        <Route path="/organizational-attainment-score-setup/*" element={<AttainmentScoreSetup/>}/>
        <Route path="/Country/*" element={<Country/>}/>
        <Route path="/State/*" element={<State/>}/>
        <Route path="/Lga/*" element={<Lga/>}/>
        <Route path="/Claim/*" element={<Claim/>}/>
        <Route path="/approval-configuration/*" element={<ApprovalConfig/>}/>
        <Route path="/zones/*" element={<Zones/>}/>
        <Route path="/score-type*" element={<ScoreType />}/>
        <Route path="/training*" element={<Training />}/>
        <Route path="/Induction*" element={<Induction/>}/>
        <Route path="/IndustrySetUp*" element={<IndustrySetUp/>}/>
        <Route path="/CompanyClass*" element={<CompanyClass/>}/>
        <Route path="/Set-Up-Interview*" element={<SetUpInterview/>}/>
        <Route path="/Route-Page-Editor*" element={<RoutePageEditor/>}/>
        <Route path="/exam-entry-level-setup*" element={<ExamEntrySetUp/>}/>
        <Route path="/coreHr-score-setup*" element={<CoreHrScoreSetUp/>}/>
        <Route path="/reset-applicant-password/*" element={<ResetApplicantPassword />} />
        <Route path="/deactivate-applicant/*" element={<DeactivateApplicant/>}/>
        <Route path="/verify-user-email" element={<VerifyEmail/>}/>
      </Routes>
      <Modal />
    </SettingModal>
    </>

  );
}
  export default Settings;